import React from 'react';
import type { AnywhereListing } from '../../types';
import { connect } from 'react-redux';
import AnywhereListingRow from './row';

type AnywhereListingsTableProps = {
  listings: AnywhereListing[];
}

function AnywhereListingsTable({ listings } : AnywhereListingsTableProps) {
  const [listingsToShow, setListingsToShow] = React.useState<AnywhereListing[]>(listings);

  const hideListing = (listingId: string) => {
    setListingsToShow(listingsToShow.filter(listing => listing.listingId !== listingId));
  };

  return (
    <div>
      <h6>DASH Listings ({listings.length})</h6>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Hide</th>
            <th>Type/ID/Status</th>
            <th>Location</th>
            <th>GUID</th>
          </tr>
        </thead>
        <tbody>
          {listingsToShow.map(listing => (
            <AnywhereListingRow
              key={listing.listingId}
              listing={listing}
              onHide={() => hideListing(listing.listingId)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  listings: state.listings.unmatchedAnywhereListings
});

export default connect(mapStateToProps, null)(AnywhereListingsTable);
